const TableConfigs = {
  pagination: {
    page: 1,
    size: 10,
    available_sizes: [10]
  }
};

export default TableConfigs;
